angular.module('lead')
    .component('leadBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/lead/_btn-options.html',
        controller: function (LeadService, LeadActivityService, LeadStatusService, PropertyDealService, LeadOfferService, Principal, FilesSimpleUploadService, FilesLibrary) {
            this.LeadService = LeadService
            this.LeadActivityService = LeadActivityService
            this.PropertyDealService = PropertyDealService
            this.LeadOfferService = LeadOfferService

            this.$onChanges = () => {
                // this.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'])

                this.isOpen = LeadService.isLeadOpen(this.item);
                this.canSendOffer = this.isOpen;
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: 'LEAD', id: this.item.id})
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: 'LEAD', id: this.item.id})
            this.delete = () => LeadService.delete(this.item)
        }
    })
